<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top">
        <div class="flex-1 font-16-30313a">材料分类</div>
      </div>
      <div class="flex-1 h-0" v-if="classifyList && classifyList.length">
        <cate-menu :not-operate="true" :menu-data="classifyList" @on-choose="onChooseMenu" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0 h-100 flex-column ptb-10 pr-20">
      <div class="flex align-center mb-10 justify-space-between">
        <div class="flex align-center">
          <div class="flex align-center mr-20">
            <div class="font-12-30313a mr-5">会计期间</div>
            <el-select v-model="inventoryPeriodValue" placeholder="请选择会计期间" class="flex-1">
              <el-option v-for="(item, index) in inventoryPeriodList" :key="item.id" :label="item.code" :value="index">
              </el-option>
            </el-select>
          </div>
          <div class="mr-20">
            <el-checkbox v-model="isCurrent">本期发生数</el-checkbox>
          </div>
          <div class="flex flex-1 justify-end">
            <div class="flex align-center mr-5 mb-5 btn-24-bg-ff" @click="exportExcel">
              <img src="/static/images/daochu.png" class="icon-14 mr-5" alt="">
              <div>导出Excel</div>
            </div>
          </div>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input type="text" placeholder="材料/品牌/规格型号/编码" v-model="keywords" clearable @keyup.enter.native="searchBtn"></el-input>
          </div>
          <button class="btn-30-bg-82b925" @click="searchBtn">搜索</button>
        </div>
      </div>
      <div class="flex-1 h-0 flex-column">
        <div class="flex-1 h-0 thColor">
          <vxe-table highlight-current-row border height="100%" :auto-resize="true" :resizable="true" ref="erpTable" show-overflow show-header-overflow size="mini" :data="tableData" @current-change="changeCurrentRow">
            <vxe-table-column title="基本信息">
              <vxe-table-column field="code" title="材料编码"></vxe-table-column>
              <vxe-table-column field="name" title="材料名称"></vxe-table-column>
              <vxe-table-column field="standard" title="规格"></vxe-table-column>
              <vxe-table-column field="model" title="型号"></vxe-table-column>
              <vxe-table-column field="salesUnit" title="单位"></vxe-table-column>
            </vxe-table-column>
            <vxe-table-column title="收入">
              <vxe-table-column field="beginningQuantity" title="期初数量"></vxe-table-column>
              <vxe-table-column field="beginningUnitPrice" title="期初单价"></vxe-table-column>
              <vxe-table-column field="beginningTotal" title="期初金额"></vxe-table-column>
              <vxe-table-column field="curIncQuantity" title="本期收入"></vxe-table-column>
              <vxe-table-column field="curIncUnitPrice" title="单价"></vxe-table-column>
              <vxe-table-column field="curIncTotal" title="金额"></vxe-table-column>
            </vxe-table-column>
            <vxe-table-column title="发放">
              <vxe-table-column field="curPayQuantity" title="本期发出"></vxe-table-column>
              <vxe-table-column field="curPayUnitPrice" title="单价"></vxe-table-column>
              <vxe-table-column field="curPayTotal" title="金额"></vxe-table-column>
              <vxe-table-column field="curBalanceQuantity" title="本期结存"></vxe-table-column>
              <vxe-table-column field="curBalanceUnitPrice" title="单价"></vxe-table-column>
              <vxe-table-column field="curBalanceTotal" title="金额"></vxe-table-column>
            </vxe-table-column>
          </vxe-table>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
      </div>
      <move-vertical :max="560" :min="150" class="mtb-5" moveDom="bottom"></move-vertical>
      <div id="moveTop" class="flex-column" style="height: 220px">
        <div class="flex align-center">
          <div class="flex align-center mr-20 cursor pb-5 relative tabActive">
            <div class="mr-5 decoration-line"></div>
            <div class="font-bold font-16-f5971d">库存量分布</div>
          </div>
        </div>
        <div class="hr"></div>
        <div class="thColor mt-10 flex-1" style="overflow-y: auto">
          <el-collapse v-model="activeNames" class="flex-1">
            <el-collapse-item :title="item.code" :name="(parseInt(index)+1)" v-for="(item, index) in inventoryOrderList" :key="index">
              <div style="max-height: 200px">
                <erp-table ref="erpTable1" :table-data="item.inventoryOrderList" :column-data="columnData1" :loading="loading2"></erp-table>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import MoveHorizon from '../../components/MoveHorizon'
import MoveVertical from '../../components/MoveVertical'
import CateMenu from '../../components/CateMenu'
import ErpTable from '../../components/ErpTable'
export default {
  name: 'inventoryStock',
  components: { Pagination, MoveHorizon, MoveVertical, CateMenu, ErpTable },
  data () {
    return {
      page: 1,
      limit: 10,
      pageSize: 0,
      pageNo: 0,
      pageTotal: 0,
      total: 0,
      keywords: null,
      classifyList: [],
      chooseMenuId: 0,
      currentClassify: {},
      inventoryPeriodList: [],
      inventoryPeriodValue: 0,
      loading: false,
      loading2: false,
      tableData: [],
      isCurrent: true,
      columnData1: [
        {
          field: 'completeTime',
          title: '供货完成时间',
          width: '150',
          formatter: ['toDateString', 'yyyy-MM-dd']
        }, {
          field: 'name',
          title: '单据类型',
          width: '120'
        }, {
          field: 'code',
          title: '单据编号',
          width: '200'
        }, {
          field: 'curIncQuantity',
          title: '收入数量',
          width: '100'
        }, {
          field: 'curPayQuantity',
          title: '发出数量',
          width: '120'
        }, {
          field: 'colorNumber',
          title: '色号',
          width: '80'
        }, {
          field: 'storehouseName',
          title: '仓库',
          width: '80'
        }, {
          field: 'remark',
          title: '说明',
          minWidth: '120'
        }
      ],
      inventoryOrderList: [],
      activeNames: 1
    }
  },
  created () { },
  mounted () {
    this.getInventoryPeriod()
  },
  methods: {
    exportExcel () {
      this.loading = true
      this.axios.post(`material/queryInventoryDetail`, {
        classifyId: this.chooseMenuId,
        inventoryPeriod: this.inventoryPeriodList[this.inventoryPeriodValue].id,
        isCurrent: this.isCurrent ? 1 : 0,
        keywords: this.keywords,
        page: this.page,
        limit: this.total
      }).then(res => {
        this.loading = false
        if (res.data.success) {
          let data = res.data.data.list
          this.$refs.erpTable.exportData({
            filename: '导出数据',
            sheetName: 'Sheet1',
            isHeader: true,
            isFooter: true,
            data
          })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onChooseMenu (menu) {
      if (this.chooseMenuId !== menu.id) {
        this.chooseMenuId = menu.id
        this.currentClassify = menu
        this.page = 1
        this.getInventoryDetail()
        // this.queryInventory()
      }
    },
    getClassify () {
      this.classifyList = []
      this.axios.post(`materialClassify/findAllClassify`, { companyId: this.$store.state.companyId, inventoryFlag: 1 }).then(res => {
        if (res.data.success) {
          this.classifyList = res.data.data
          this.getDefaultId(this.classifyList)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getDefaultId (list) {
      if (list && list.length) {
        let classify = list[0]
        this.chooseMenuId = classify.id
        this.currentClassify = classify
        this.$nextTick(() => {
          this.getInventoryDetail()
        })
      }
    },
    getInventoryPeriod () {
      this.axios.post(`inventoryPeriod/currentList`, { companyId: this.$store.state.companyId }).then(res => {
        if (res.data.success) {
          if (res.data.data.length > 0) {
            this.inventoryPeriodValue = res.data.data.length - 1
          }
          this.inventoryPeriodList = res.data.data
          this.getClassify()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getInventoryDetail () {
      this.axios.post(`material/queryInventoryDetail`, {
        classifyId: this.chooseMenuId,
        inventoryPeriod: this.inventoryPeriodList[this.inventoryPeriodValue].id,
        isCurrent: this.isCurrent ? 1 : 0,
        keywords: this.keywords,
        page: this.page,
        limit: this.limit
      }).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    changeCurrentRow ({ row }) {
      this.currentRow = row
      this.$nextTick(() => {
        this.queryInventory()
      })
    },
    queryInventory () {
      let params = {
        companyId: this.$store.state.companyId,
        materialId: this.currentRow.id
      }
      if (this.isCurrent) {
        params.inventoryPeriod = this.inventoryPeriodList[this.inventoryPeriodValue].id
      }
      this.loading2 = true
      this.axios.post(`order/queryInventoryOrderList`, params).then(res => {
        this.loading2 = false
        if (res.data.success) {
          this.inventoryOrderList = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    searchBtn () {
      this.page = 1
      this.getInventoryDetail()
    },
    jump (page) {
      this.page = page
      this.getInventoryDetail()
    }
  },
  watch: {
    isCurrent () {
      this.getInventoryDetail()
      this.queryInventory()
    },
    inventoryPeriodValue (val) {
      this.getInventoryDetail()
      // this.currentRow = {}
      // this.queryInventory()
    },
    keywords (val) {
      if (val === '') {
        this.getInventoryDetail()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.thColor /deep/ .el-collapse-item__header {
  padding: 0 10px;
  background: #f5971d !important;
  color: #ffffff;
  height: 30px;
}
.left-top {
  display: flex;
  align-items: center;
  padding: 0 10px 0 20px;
  border-bottom: 1px solid #e2e2e2;
  height: 40px;
  text-align: left;
  cursor: pointer;
}
.search {
  overflow: hidden;
}
.search /deep/.el-input__inner {
  padding-left: 0;
  border: none;
  outline: none;
}
.thColor /deep/ .vxe-header--column {
  border: 2px #e2e2e2 !important;
  border-right: dashed 1px #e2e2e2 !important;
  background-color: #f3f4f7 !important;
}
.thColor /deep/ .vxe-header--row {
  color: #30313a !important;
}
.thColor /deep/.vxe-table.t--border .vxe-header--column .vxe-cell {
  color: #30313a !important;
}
.thColor /deep/ .col--group {
  border-bottom: 1px solid #e2e2e2 !important;
  background: #f5971d !important;
  .vxe-cell {
    color: #fff !important;
  }
}
.thColor /deep/.vxe-table.t--border .col--group.vxe-header--column .vxe-cell {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/inventoryStock.vue